<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container mt-4 mb-2" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="container" >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='""' class="h2 text-center" >
                <template #default>خبرنامه وکلای دزفول   </template>
                </m-h1><m-post-slider-900 v-bind='{...{"swiperPerViewSM":1,"swiperPerViewMD":2,"swiperPerViewLG":3,"postCard":"mPostCard2","cardLink":true,"contentCategories":["\u0627\u0633\u0644\u0627\u06cc\u062f\u0631-\u067e\u0633\u062a1"],"stores_filter":null},...{}}' :style='""' class="" ></m-post-slider-900></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="container p-0hide-products-slider-show-more mb-3" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row mx-auto justify-content-around card-206-wrapper " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-12   p-0 text-lg-right text-center " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"border-radius:25px;\nbox-shadow: 0px 10px 35px 0px rgba(198.66466743310934, 51.78987162785041, 239.67167358398436, 0.11);\nbackground:#D6EBFF;"' class="container  border py-2 px-3" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"font-size: 17px;"' class="col-12  text-right" >
                <template #default>   <m-span v-bind='{...{},...{}}' :style='""' class="text-primary font-weight-bold " >
                <template #default>انتخاب    </template>
                </m-span><m-span v-bind='{...{},...{}}' :style='"font-size:20px"' class="mx-1  font-weight-bold " >
                <template #default>سردبیر   </template>
                </m-span></template>
                </m-div><m-posts-1 v-bind='{...{"cardLink":true,"slicer":24,"contentType":"post","paginate":true,"categoryPanel":false,"flatCategoriesShape":false,"contentCategories":["\u0627\u0646\u062a\u062e\u0627\u0628-\u0633\u0631\u062f\u0628\u06cc\u0631"],"postCard":"mPostCard310","postCardClass":"mb-2 col-lg-4 col-md-6","stores_filter":null},...{}}' :style='""' class="mt-3" >
                <template #p-1>   </template>
                
                <template #p-2>   </template>
                </m-posts-1></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mPostSlider900 from '@moeinmdn/miw-alpha-components/src/package/Post/Slider/PostSlider900'; import mSpan from '@moeinmdn/miw-alpha-components/src/package/Tags/Span'; import mPosts1 from '@moeinmdn/miw-alpha-components/src/package/Post/Posts/Posts1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH1,mPostSlider900,mSpan,mPosts1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
